import { clsx } from "clsx";
import { useEffect, useState, useRef, useMemo } from "react";

function FileIcon() {
  const filenames = useMemo(
    () => [
      { name: "coa", time: 800 },
      { name: "bnp", time: 1600 },
      { name: "ctl", time: 2400 },
      { name: "ct2", time: 3200 },
      { name: "upn", time: 4000 },
    ],
    []
  );

  const [visibleIndex, setVisibleIndex] = useState(-1); // 控制圖片的浮現
  const [showText, setShowText] = useState(false); // 控制文字的顯示
  const [isStarted, setIsStarted] = useState(false); // 控制動畫啟動
  const outerDivRef = useRef(null); // 用於觀察外層 div 的參考

  //   useEffect(() => {
  //     const observer = new IntersectionObserver(
  //       ([entry]) => {
  //         if (entry.isIntersecting) {
  //           setIsStarted(true); // 啟動動畫
  //         }
  //       },
  //       { threshold: 0.1 } // 當外層 div 至少有 10% 可見時觸發
  //     );

  //     if (outerDivRef.current) {
  //       observer.observe(outerDivRef.current);
  //     }

  //     return () => {
  //       if (outerDivRef.current) {
  //         observer.unobserve(outerDivRef.current);
  //       }
  //     };
  //   }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsStarted(true); // 啟動動畫
        }
      },
      { threshold: 0.1 }
    );

    const currentRef = outerDivRef.current; // 保存當前的 ref
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef); // 使用保存的 ref
      }
    };
  }, []);

  useEffect(() => {
    if (isStarted) {
      // 設定每個圖片浮現的時間
      filenames.forEach((file, index) => {
        setTimeout(() => {
          setVisibleIndex((prev) => Math.max(prev, index)); // 更新可見的索引
        }, file.time);
      });

      // 設定文字出現的時間
      const textTimeout = setTimeout(() => {
        setShowText(true); // 顯示文字
      }, 4800); // 不修改這個值

      return () => clearTimeout(textTimeout);
    }
  }, [isStarted, filenames]);

  return (
    <div ref={outerDivRef}>
      <div className="flex flex-col items-center lg:gap-8 gap-4">
        <div className="flex flex-row lg:gap-8 gap-4">
          {filenames.map((file, index) => (
            <div className="flex flex-row items-center gap-2" key={index}>
              <img
                src={`./demo4Pic/${file.name}.webp`}
                className="w-8 h-8 lg:w-12 lg:h-12"
                alt=""
              />
              <img
                src="./demo4Pic/check.webp"
                className={`w-4 h-4 lg:w-8 lg:h-8 transition-opacity duration-500 ${
                  index <= visibleIndex ? "opacity-100" : "opacity-0"
                }`}
                alt=""
              />
            </div>
          ))}
        </div>
      </div>

      {/* 文字段落 */}

      <div
        className={clsx([
          "text-gray-500 text-md lg:text-xl tracking-wider text-center py-8 leading-6 lg:leading-8 transition-opacity duration-500",
          showText ? "opacity-100" : "opacity-0",
        ])}
      >
        上傳後系統自動判斷檔名，帶入段代碼等資料，
        <br />
        您只需選擇坐標系統，其餘的交給lookie。
      </div>
    </div>
  );
}

export default FileIcon;
